import { Injectable, EventEmitter } from '@angular/core';
import { ScalesService } from './scales.service';
import { ChordsService } from './chords.service';
import { InstrumentName, instrument, Player } from 'soundfont-player';
import { Sound } from './sound';
import { ChordsSchemasService } from './chords-schemas.service';
declare var window: any;
export type MoreSoundfonts = 'drums' | 'percussion';

@Injectable({
  providedIn: 'root'
})
export class PlayService {
  private audioContext: any;
  private sounds: Sound[] = [];
  public detune = 0;

  constructor(
    public scalesService: ScalesService,
    public chordsService: ChordsService,
    public chordsSchema: ChordsSchemasService
  ) {}
  initAudioContext() {
    if (this.audioContext) {
      return;
    }
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    this.audioContext = new AudioContext();
  }
  load(soundfontName: InstrumentName | MoreSoundfonts, small: boolean): Promise<Sound> {
    this.initAudioContext();
    return new Promise<Sound>((resolve, reject) => {
      const suffix = small ? '-mp3-small.js' : '-mp3.js';
      instrument(
        this.audioContext,
        soundfontName as InstrumentName,
        { nameToUrl(name: string, soundfont: any, format: any) {
          return '/assets/soundfont/' + name + suffix;
        }
      }).catch((error) => {
          console.log('Instrument Error');
          console.log(error);
      }).then((player: Player | void) => {
        if (player) {
          const sound: Sound = new Sound(
            soundfontName,
            player,
            this.audioContext,
            this.scalesService,
            this.chordsService,
            this.chordsSchema
          );
          if (soundfontName === 'electric_bass_finger') {
            sound.detune = 12;
          }
          this.sounds.push(sound);
          resolve(sound);
        }
      });
    });
  }
  unload(sound?: Sound) {
    if (typeof sound === 'undefined') {
      this.sounds = [];
    } else {
      const index = this.sounds.indexOf(sound);
      if (index !== -1) {
        this.sounds.splice(index, 1);
      }
    }
    // this.loaded = false;
  }
  notePlay(note: number, volume?: number, delay?: number, duration?: number) {
    if (this.sounds.length > 0) {
      this.sounds[0].notePlay(note, volume, delay, duration);
    }
  }
  scalePlay(
    name: string,
    start: number,
    bpm: number,
    volume: number,
    duration: number,
    withOctave: boolean,
    onEnd: any
  ) {
    if (this.sounds.length > 0) {
      this.sounds[0].scalePlay(
        name,
        start,
        bpm,
        volume,
        duration,
        withOctave,
        onEnd
      );
    }
  }
  chordPlay(
    name: string,
    start: number,
    inversion: number,
    arpeggio: boolean,
    bpm: number,
    volume: number,
    duration: number,
    onEnd: any
  ) {
    if (this.sounds.length > 0) {
      this.sounds[0].chordPlay(
        name,
        start,
        inversion,
        arpeggio,
        bpm,
        volume,
        duration,
        onEnd
      );
    }
  }
}
